import { Flex, IconButton, Text, Button, Icon } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { IconClose, IconTrashbin, IconThunder } from 'assets/icons';
import { FloatingFooter } from 'components/Table';

interface ITasksTableFooter {
  selectedFlatRows: any[];
  toggleAllRowSelected: (value?: boolean) => void;
  handleBulkActivate: (value: any[]) => void;
  handleBulkDelete: (value: any[]) => void;
}

const TasksTableFooter: React.FC<ITasksTableFooter> = ({
  selectedFlatRows,
  toggleAllRowSelected,
  handleBulkActivate,
  handleBulkDelete,
}) => {
  const { t } = useTranslation(['common', 'jobsTasks']);

  return (
    <FloatingFooter>
      <Flex alignItems="center">
        <IconButton
          aria-label="Close button"
          icon={<Icon as={IconClose} h="10px" w="10px" />}
          onClick={() => toggleAllRowSelected(false)}
          variant="unstyled"
        />
        <Text>
          ({selectedFlatRows.length}) {t('common:selected')}
        </Text>
      </Flex>
      <Flex gridGap={2}>
        <Button
          leftIcon={
            <Icon
              as={IconThunder}
              sx={{
                path: { fill: 'primary.500' },
              }}
            />
          }
          variant="ghost"
          bg="primary.50"
          _hover={{ bg: 'primary.100' }}
          onClick={() => handleBulkActivate(selectedFlatRows)}
        >
          {t('jobsTasks:activateTask')}
        </Button>
        <Button
          leftIcon={
            <Icon
              as={IconTrashbin}
              sx={{
                path: { fill: 'secondary.500' },
              }}
            />
          }
          colorScheme="secondary"
          variant="ghost"
          bg="secondary.50"
          _hover={{ bg: 'secondary.100' }}
          onClick={() => handleBulkDelete(selectedFlatRows)}
        >
          {t('jobsTasks:deleteTask')}
        </Button>
      </Flex>
    </FloatingFooter>
  );
};

export default TasksTableFooter;
